import React, { useMemo } from 'react'
import { Flex, Grid, Stack, Text } from '@mantine/core'

import { SubtleButton } from '@/components/Event/NewScript/components/common/Layout/SubtleButton'
import {
  ActionContainer,
  ActionTitle,
} from '@/components/Event/NewScript/components/common/ScriptTimeline'
import { EventResultData } from '@/components/Event/NewScript/components/Review/EventCancelledCard/EventCancelledCardEdit'
import {
  DEPOSITION_ENDED_OPTIONS_LABEL,
  DepositionResult,
  REASON_FOR_CNA_LABEL,
  ReasonForCna,
} from '@/constants'
import { Event } from '@/types'
import {
  formatTimeInTimezoneWithAbbreviation,
  getEventTimezone,
} from '@/utils/time'

type Props = {
  title?: string
  onEditClick: () => void
  value: EventResultData
  event: Event
}

export const EventCancelledCardView: React.FC<Props> = ({
  title,
  onEditClick,
  value: { result, notes, reason_for_cna, other_reason, last_timestamp },
  event,
}) => {
  const eventTimezone = getEventTimezone(event)
  const { firstLine, secondLine } = useMemo(() => {
    const firstLine = DEPOSITION_ENDED_OPTIONS_LABEL[result as DepositionResult]

    if (result !== DepositionResult.CNA) {
      return {
        firstLine,
        secondLine: (notes as string) ?? '',
      }
    }

    return {
      firstLine,
      secondLine: `${formatTimeInTimezoneWithAbbreviation(
        last_timestamp as string,
        eventTimezone,
      )} – ${reason_for_cna ? REASON_FOR_CNA_LABEL[reason_for_cna as ReasonForCna] : 'unknown reason for CNA'}${other_reason ? ' – ' + (other_reason as string) : ''}`,
    }
  }, [
    result,
    notes,
    reason_for_cna,
    other_reason,
    last_timestamp,
    eventTimezone,
  ])

  return (
    <ActionContainer outer>
      {title && <ActionTitle mb="md">{title}</ActionTitle>}
      <ActionContainer>
        <Grid grow>
          <Grid.Col span={10}>
            <Stack>
              <Text>{firstLine}</Text>
              <Text>{secondLine}</Text>
            </Stack>
          </Grid.Col>
          <Grid.Col span={2}>
            <Flex align="center" justify="end" h={'100%'} w="100%">
              <SubtleButton p={0} onClick={onEditClick}>
                Edit
              </SubtleButton>
            </Flex>
          </Grid.Col>
        </Grid>
      </ActionContainer>
    </ActionContainer>
  )
}
